import { DotLottiePlayer } from '@dotlottie/react-player';
import { Typography } from '@mui/material';
import { ResultsProps } from '@pages/SavingsCalculator/types';
import { formatCurrency } from '@utils/formater';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ActiveBackX from '../images/ActiveBackX';
import BackX from '../images/BackX';
import Cerdito from '../images/Cerdito.json';
import Pig from '../images/Pig';

const Results = ({ value }: ResultsProps) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-80">
      <Typography
        variant="overline"
        className={clsx(
          'z-10 block max-w-40  !text-sm !normal-case',
          value ? 'text-white' : 'text-slate-400'
        )}
      >
        {t('svngsResultTitle')}
      </Typography>
      <div
        className={clsx(
          'flex gap-1 items-end border px-3 py-2 my-8',
          value > 0 ? 'border-[#0059CC] bg-[#0059CC]' : 'border-slate-400'
        )}
      >
        <Typography
          variant="h4"
          className={clsx('z-10', value ? 'text-white' : 'text-slate-400')}
        >
          {formatCurrency(value || 0)}
        </Typography>
        <Typography
          variant="body2"
          className={clsx(
            'z-10 !leading-8',
            value ? 'text-white' : 'text-slate-400'
          )}
        >
          USD
        </Typography>
      </div>
      {value ? (
        <DotLottiePlayer
          className="!p-0 relative z-10"
          src={Cerdito}
          autoplay
          loop
        />
      ) : (
        <Pig />
      )}
      {value ? <ActiveBackX /> : <BackX />}
    </div>
  );
};

export default Results;
